import { render, staticRenderFns } from "./returnOld.vue?vue&type=template&id=03709162&scoped=true"
import script from "./returnOld.vue?vue&type=script&lang=js"
export * from "./returnOld.vue?vue&type=script&lang=js"
import style0 from "./returnOld.vue?vue&type=style&index=0&id=03709162&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03709162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03709162')) {
      api.createRecord('03709162', component.options)
    } else {
      api.reload('03709162', component.options)
    }
    module.hot.accept("./returnOld.vue?vue&type=template&id=03709162&scoped=true", function () {
      api.rerender('03709162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/returnNoteRecord/component/returnOld.vue"
export default component.exports